import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { SEOMetaTags } from '../../components/shared/SEOMetaTags';
import { BookOpen, Quote, ChevronDown, MapPin, User, Calendar } from 'lucide-react';

// --- Données des discours organisées ---
const speeches = [
    {
        id: 'atangana',
        title: 'Le mot de Clément ATANGANA, Président du conseil constitutionnel du Cameroun',
        speaker: 'Clément ATANGANA',
        position: 'Président du Conseil Constitutionnel',
        country: 'Cameroun',
        category: 'Institution judiciaire',
        date: '14 avril 2020',
        excerpt: 'MOT DE REMERCIEMENT DU PRESIDENT DU CONSEIL CONSTITUTIONNEL A L\'OCCASION DE LA CEREMONIE DE REMISE DU PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES JUDICIAIRES',
        fullContent: `MOT DE REMERCIEMENT DU PRESIDENT DU CONSEIL CONSTITUTIONNEL A L'OCCASION DE LA CEREMONIE DE REMISE DU PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES JUDICIAIRES

Yaoundé le 14 avril 2020

Monsieur le ministre Etoundi Ngoa, cher Ami
Madame et messieurs les membres du conseil constitutionnel
Monsieur le secrétaire général constitutionnel
Monsieur le président du jury du PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES JUDICIAIRES
Au nom de la communauté universitaire de Yaoundé I et en mon nom propre, je voudrais d'entrée de jeu,…`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2022/09/download-5.jpg'
    },
    {
        id: 'sosso',
        title: 'Le mot du Pr Maurice Aurélien SOSSO, Recteur de l\'Université de Yaoundé I',
        speaker: 'Pr Maurice Aurélien SOSSO',
        position: 'Recteur de l\'Université de Yaoundé I',
        country: 'Cameroun',
        category: 'Éducation supérieure',
        date: '10 janvier 2020',
        excerpt: 'REMISE DU PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES MANAGERIALES 2019 PAR INTERNATIONAL COMMITE OF EXCELLENCE(ICE)',
        fullContent: `REMISE DU PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES MANAGERIALES 2019 PAR INTERNATIONAL COMMITE OF EXCELLENCE(ICE)

Salle des Actes, vendredi 10 janvier 2020

Monsieur le Président du jury du PRIX SOUS REGIONAL DES MEILLEURES PRATIQUES MANAGERIALES 2019
Au nom de la communauté universitaire de Yaoundé I et en mon nom propre, je voudrais d'entrée de jeu,…`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2021/05/insignes-new-macaron-rouge-1.jpg'
    },
    {
        id: 'okemba',
        title: 'MOT DU MINISTRE SECRETAIRE GENERAL DU CONSEIL NATIONAL DE SECURITE/CONGO',
        speaker: 'S.E JEAN DOMINIQUE OKEMBA',
        position: 'Ministre Secrétaire Général du Conseil National de Sécurité',
        country: 'Congo',
        category: 'Sécurité nationale',
        date: '2024',
        excerpt: 'C\'est avec une grande humilité et une immense reconnaissance que j\'accepte ce prestigieux prix d\'excellence du leadership en strategie et securité',
        fullContent: `Monsieur le President du comité consultaif de l'ICE
Messieurs les Membres de la Delegation de l'ICE
Chers Collegues
Chers Invités
Mesdames et Messieurs

C'est avec une grande humilité et une immense reconnaissance que j'accepte ce prestigieux prix d'excellence du leadership en strategie et securité dans un domaine ou les satisfecits sont plutôt rares.

Je tiens ici et maintenant à remercier chaleureusement l'ICE ,ce cabinet d'expertise independant ,nanti d'universitaires,de personnalités indeendantes,leaders de la societé civile,managers et hommes de medias et de culture du continent et de la diasora africaine,qui ,par leur travail acharné de recherche et de devouement ,a rendu possible cet evenement.

Je dois cet honneur :

– Premierement à Son Excellence Denis SASSOU NGUESSO,President de la Republique ,Chef de l'Etat,President du Conseil National de Securité,qui a fait de moi,ce que je suis devant vous ;il est la sève qui me nourrit de tous les savoirs : – le savoir-etre, -le savoir–faire,et la savoir-devenir ;

-Deuxiemement ,à mon pays ,le Congo qui m'a tout donné et que je dois en retour à tous egards ;

-Troisiement ,au conseil national de securité,institution qui est le fer de lance de mon devouement.

Je voudrais dire merci au jury de l'ICE d'avoir cru en moi ,en portant son choix sur ma modeste personne à travers le continent Africain

Un merci special à ma famille et à mes proches pour leur soutien et leur confiance indefectible qui ne m'ont jamais fait defaut.

Ce prix n'est as seulement le mien ,mais aussi,dedié à une celebration de l'effort collectif et des encouragements à poursuivre la marche pour notre bien commun.

Il contribue à booster davantage nos engagemments à faire tout ce qui est en notre pouvoir de se depasser afin de garantir la paix et la securité au plus grand nombre,si cher au President de la reublique,qui en a fait son credo de tous les temps.

Nous voudrions en etre continuellement dignes ,et qu'au-delà de l'honneur qui nous echit,c'est egalement un devoir qui nous oblige.

Merci à tous pour cet honneur,je vous remercie fraternellement.`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2025/01/Jean-Dominique-Okemba-295x300.jpg'
    },
    {
        id: 'sana',
        title: 'Allocution de Monsieur Yvon SANA BANGUI / Gouverneur de la Banque des Etats de l\'Afrique Centrale (BEAC)',
        speaker: 'Monsieur Yvon SANA BANGUI',
        position: 'Gouverneur de la Banque des Etats de l\'Afrique Centrale (BEAC)',
        country: 'République Centrafricaine',
        category: 'Banque centrale',
        date: '2024',
        excerpt: 'C\'est un réel plaisir pour moi de vous compter parmi nous à l\'occasion de cette cérémonie dédiée à la remise officielle du Prix du Mérite Panafricain 2024.',
        fullContent: `Messieurs les membres du Gouvernement de la BEAC,
Monsieur le Président du Comité Consultatif de l'International Committee of Excellence (ICE),
Chers Collaborateurs,
Distingués invités,
Mesdames, Messieurs,

C'est un réel plaisir pour moi de vous compter parmi nous à l'occasion de cette cérémonie dédiée à la remise officielle du Prix du Mérite Panafricain 2024.

Je ne pourrais m'empêcher d'exprimer mon agréable surprise de recevoir ce Prix, à un moment où je ne m'y attendais nullement. Ce sentiment est d'autant plus fort que je découvre, à travers cette action remarquable, le Cabinet « International Committee of Excellence (ICE) », dont l'engagement à promouvoir l'Excellence à l'échelle continentale et sous-régionale mérite d'être salué.

Je voudrais donc adresser mes sincères remerciements et ma profonde reconnaissance aux membres du Jury qui m'ont décerné ce Prix que je partage avec l'ensemble du Gouvernement et du personnel de la Banque des Etats de l'Afrique Centrale (BEAC).

Au-delà de ma personne, cette distinction nous honore tous et constitue une reconnaissance légitime de nos efforts collectifs en matière d'éthique et de déontologie. Elle vient également rehausser l'image de notre Banque Centrale et renforcer notre détermination à inscrire nos actions dans la transparence, la rigueur et l'intégrité.

En effet, le Gouvernement de la Banque Centrale que j'ai l'insigne honneur de diriger, a impulsé depuis 2024 une nouvelle dynamique visant à renforcer l'application du Code de Déontologie Professionnelle adopté en 2010 par le Comité Ministériel de l'Union Monétaire de l'Afrique Centrale (UMAC).

A cet égard, nous avons renforcé les moyens financiers et la gouvernance de notre Cellule de Déontologie, pour lui permettre d'assurer désormais de manière constante la mise en application des normes et règles éthiques à la BEAC. C'est ainsi qu'elle a commencé à prodiguer des conseils déontologiques sur des thématiques essentielles telles que le harcèlement, le respect du droit, le professionnalisme ou encore les conflits d'intérêts.

En outre, nous avons adopté un Plan pluriannuel de mise en œuvre de la déontologie à la BEAC, avec pour ambition de hisser nos standards éthiques au niveau des meilleurs pratiques universellement admises en la matière. Ce Plan prévoit notamment le renforcement du cadre juridique avec la publication des textes infra-codes, l'intensification des actions de sensibilisation à l'endroit du Gouvernement de la Banque Centrale, du personnel et des prestataires ainsi que la digitalisation du dispositif d'alerte éthique pour plus d'efficacité et de réactivité.

Par ailleurs, le Comité de Déontologie, organe délibérant de l'éthique à la Banque Centrale, a été restructuré et s'est déjà prononcé sur plusieurs manquements aux règles éthiques. Il a également diffusé, pour la première fois, des supports de communication destinés à vulgariser la déontologie au sein de la BEAC.

Ces actions soulignent l'importance que la BEAC accorde à l'éthique et à l'intégrité, deux critères qui nous ont valu cette marque de reconnaissance de la part d'observateurs indépendants.

Messieurs les membres du Gouvernement de la BEAC,
Chers Collaborateurs,
Mesdames, Messieurs,

L'attribution du Prix du Mérite Panafricain 2024 constitue pour nous une source de motivation renouvelée. Elle nous incite à faire preuve d'un engagement sans faille et d'un sens élevé du devoir dans l'accomplissement de nos missions, pour toujours mériter la confiance du public et des Etats membres

Dans le même temps, nous devons poursuivre les réformes entreprises, notamment dans le cadre du Plan Stratégique de la Banque (PSB), afin d'améliorer la gouvernance et les performances de notre Banque Centrale et ainsi, renforcer sa crédibilité.

A ce titre, j'invite l'ensemble du personnel à adopter, en toute circonstance, une conduite responsable et empreinte d'intégrité, de rigueur, d'honnêteté et de professionnalisme. Chaque agent doit s'acquitter des responsabilités qui lui sont confiées dans le strict respect des normes, procédures et instructions qui régissent nos activités. C'est dans l'abnégation que nous bâtirons une BEAC exemplaire, porteuse d'une culture d'excellence et d'intégrité.

Monsieur le Président du Comité Consultatif de International Committee of Excellence (ICE),

Je suis particulièrement fier de recevoir cette distinction de votre part. Je vous remercie ainsi que votre délégation pour votre présence à cette cérémonie dont nous garderons un souvenir impérissable.

J'associe également à ces remerciements toute l'équipe de « l'International Committee of Excellence (ICE) » qui œuvre pour l'émergence d'une Afrique prospère, guidée par les valeurs du mérite, de l'innovation et de l'excellence.

Je formule le vœu que vos initiatives soient couronnées de succès afin d'inspirer d'autres institutions et organes de notre Sous-région.

Vive l'International Committee of Excellence (ICE),Vive la Banque des Etats de l'Afrique Centrale (BEAC), Je vous remercie pour votre aimable attention.`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2025/04/YV-SANA.jpg'
    },
    {
        id: 'allah-ridy',
        title: 'Allocution de Dr Allah -Ridy KONE PCA Université Emi-Koussi DGA SONAMINE TCHAD',
        speaker: 'Dr Allah-Ridy KONE',
        position: 'PCA Université Emi-Koussi DGA SONAMINE',
        country: 'Tchad',
        category: 'Éducation supérieure',
        date: '2022',
        excerpt: 'Je suis très honoré de me retrouver parmi vous dans de circonstances exceptionnelles et inattendues pour célébrer avec vous ce décernement du prix de l\'intégrité 2021.',
        fullContent: `Je suis très honoré de me retrouver parmi vous dans de circonstances exceptionnelles et inattendues pour célébrer avec vous ce décernement du prix de l'intégrité 2021. Lorsque ma secrétaire m'a tendu le document qui m'informe de l'intention de l'ICE – International Committee of Excellence pour m'attribuer cette distinction, j'ai cru que c'était du bluff et que cette organisation se serait trompée d'adresse. Surtout que parmi les lauréats qu'elle a eu à honorer figurent quatre (4) éminents chefs d'Etat d'Afrique inclus le Général Mahamat Idriss Déby Itno, Président du Conseil Militaire de Transition, Président de la République Chef de l'Etat. Lui au moins a droit à ce genre de prix. Car depuis son accession à la magistrature suprême, beaucoup de bonnes choses se sont réalisées au profit de la population.

J'ai tout de suite passé un coup de fil aux concernés qui m'ont confirmé que c'était effectivement moi. Mon cœur était débordé d'émotion. Qui au représentant de l'ICE de me dire que le monde est un village planétaire. Les gens suivent nos actions au moyen des informations dont ils disposent sur les ondes, par les média et les réseaux sociaux. J'ai simplement dit merci.

Mesdames et Messieurs,

Je vais humblement confesser que je ne suis pas le seul au Tchad à mériter ce prix. Il y en a ceux qui accomplissent et continuent à accomplir des œuvres plus grandioses que moi. Et puis je ne peux pas aussi prétendre déclarer que si j'obtiens ce prix, c'est par mes efforts personnels. Beaucoup ont contribué à ma réussite.

La raison pour laquelle, je dédie ce Prix à mes parents surtout à mon père feu Koné Simon qui m'a tracé la voie de bienfaisance et de l'amour de mon prochain. Il a cheminé avec moi dans le Grand Mayo Kebbi et la Tandjilé où il a créé des écoles et encadré des paysans dans l'agriculture, et aussi à ma mère, la princesse fille de Guedna Azina kolon qui m'a appris l'endurance et la persévérance.

La dédicace est également vouée à la dénomination protestante – Eglise Adventiste du 7ème Jour de qui j'ai reçu la formation d'un leadership intégral de l'homme et de tout homme. Là-bas elle m'a enseigné à servir et non se servir. Je marque un sceau particulier à ma merveilleuse famille qui m'a accompagné dans mon parcours en traversant les vallées et les collines.

Je dédie ce prix à la chefferie traditionnelle du Grand Mayo Kebbi et Tandjilé et les élites du Bureau Exécutifs Kodomma avec qui nous nous investissons dans les résolutions des conflits intercommunautaires. Sans cette synergie ce prix de l'intégrité ne serait pas concédé.

Je dédie ce prix aux étudiants et leurs parents sans lesquels l'université Emi Koussi n'existerait pas.

Je voue cette grande distinction au personnel de l'Université Emi Koussi (techniciens de surface, enseignants chercheurs, staff administratif et académique) pour leur dévouement et du sérieux qu'ils mettent dans le travail et surtout le travail bien fait. Cette université gravit tout doucement vers le sommet du savoir grâce à la dextérité des principaux administrateurs Dr. Casimir Béassoum Dodiguen, son bras droit François-Xavier Bigaoula et les autres anciens et nouveaux collaborateurs.

Je dédie ce prix également à la Société Nationale du Ciment (SONACIM) avec à la tête le Directeur Général Hamat Ishaka Diar dont l'étroitesse de notre collaboration donne une impulsion à notre entreprise.

Je ne pourrais oublier le ministère de l'Enseignement Supérieur, de la Recherche Scientifique et de l'innovation qui a été toujours à nos côtés pour nous encourager et nous orienter dans l'encadrement vers l'excellence.

Je ne cesserai guère de magnifier le Maréchal du Tchad Idriss Déby Itno que j'ai eu le privilège de le rencontrer à Yaoundé pendant sa visite de travail. Au cours de l'audience qu'il m'avait accordé, il m'a demandé de rentrer au pays comme il l'avait déclaré dans son discours qu'il a besoin de la jeunesse qui a de l'audace et qui ose. J'ai obtempéré. D'où la création de l'Université Emi Koussi.

Enfin je remercie le Camarade Dr. Haroun Kabadi et le Grand parti rassembleur le Mouvement Patriotique du Salut (MPS) pour son soutien inlassable apporté à la réussite de cet événement. Par cet acte je lui témoigne toute ma gratitude.

Ce Prix, pour moi, ne servira pas à orner un salon. Aidez-moi vous tous, toutes les élites tchadiennes, gouvernements, sociétés civiles et communautés, aidez-moi à traduire le Prix de l'Intégrité en actions concrètes en luttant pour la réduction de la pauvreté et le chômage, à combattre la délinquance sénile et juvénile traduites dans les consommations de produits narcotiques, à éliminer les autres pratiques traditionnelles affectant la santé et les droits des filles et des femmes et enfin à offrir une formation de l'excellence pour répondre à la loi de l'offre et la demande de l'emploi.

Ainsi je vais arriver donc chez chacun de vous pour solliciter votre collaboration et votre appui. Muni de l'esprit et de l'idéal, n'essayez pas de fermer la porte puisque je vais la pousser.

J'aime aussi remercier le Jury de International Committee of Excellence qui a organisé cet événement, qui a déployé tous les efforts nécessaires en se déplaçant au Tchad, pays de Toumai. Si ce prix est pour vous une simple distinction, pour moi et ma communauté c'est grand honneur. Acceptez tous nos mots de gratitude.

Enfin, je voudrais exprimer ma reconnaissance à tous nos illustres invités, qui ont bien voulu effectuer le déplacement, pour rehausser de leur présence, si distinguée, l'éclat de cette manifestation. Il est heureux de noter que l'institution de ce prix nous a offert l'occasion de nous retrouver et de réaffirmer notre ambition de construire un Tchad uni, fort et prospère, une administration moderne et efficace, au service de la Nation.

Ce prix est un défi continuel et nous devons, chacun à son niveau de responsabilité, nous en imprégner suffisamment pour influencer positivement notre environnement de travail, avec toute la détermination et l'énergie nécessaires. Je ferai donc en sorte que ce prix se crédibilise davantage, pour le bénéfice de tous. La reconnaissance du mérite est un impératif de la gestion participative. Elle inculque à ma modeste personne les réflexes de bonnes habitudes, la conscience professionnelle et l'engagement à se mettre au service de la nation.

Je vous remercie de votre aimable attention.`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2022/02/photo-dr-allah-ridy-en-tauge-new-fin.jpg'
    },
    {
        id: 'tagni',
        title: 'MOT DU Pr MICHELE SARTRE TAGNI : DIRECTRICE DU CMC',
        speaker: 'Pr MICHELE SARTRE TAGNI',
        position: 'Directrice du Centre Médical La Cathédrale',
        country: 'Cameroun',
        category: 'Santé',
        date: '2022',
        excerpt: 'Nous sommes très honorés d\'avoir été choisi par ICE pour recevoir le prix sous régional de l\'excellence et de l\'innovation médicale 2022.',
        fullContent: `Nous sommes très honorés d'avoir été choisi par ICE pour recevoir le prix sous régional de l'excellence et de l'innovation médicale 2022.

En effet, tous les efforts consentis avec persévérance par les fondateurs, nos médecins et notre personnel ont permis de réaliser un centre diagnostic performant grâce à un plateau technique doté des équipements de dernière génération répondant aux standards internationaux.

Le centre médical la cathédrale dispose :

d'un service d'imagerie médicale complet avec en dernière acquisition une IRM 1.5T neuve, un appareil d'échographie haut de gamme offrant de nombreuses possibilités,

d'une solution innovante d'archivage et de diffusion numérique,

d'un service d'endoscopies diagnostic et thérapeutique de qualité

d'un laboratoire d'analyses médicales

d'un pôle cardiologique avec équipement complet lié à l'imagerie médicale par le Coroscan et IRM cardiaque,

D'un service de soins avec hospitalisation de jour.

Le centre est ouvert à de nombreuses spécialités telles que : (La Neurologie, L'Ophtalmologie, La Pneumologie, La Pédiatrie, L'Urologie, La Gynécologie, L'Endocrinologie, La Néphrologie, l'ORL, La Kinésithérapie, l'oncologie, la rhumatologie etc…)

Notre ambition a toujours été d'offrir aux patients des soins de qualité et viser l'excellence dans notre domaine.

Ce prix montre que nos efforts et les résultats obtenus sont reconnus à l'international et nous encourage à continuer dans cette voie.`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2022/09/cmc-dr-sartre-3-fleurie.jpg'
    },
    {
        id: 'ngombaye',
        title: 'DISCOURS DE MONSIEUR LE PCA DE LA CLINIQUE MEDICO-CHIRURGICALE PROVIDENCE NDJAMENA',
        speaker: 'Dr NGOMBAYE DJAIBE',
        position: 'PCA de la Clinique Medico-Chirurgicale Providence',
        country: 'Tchad',
        category: 'Santé',
        date: '2023',
        excerpt: 'C\'est un insigne honneur pour nous que de prendre la parole devant d\'éminents personnalités.',
        fullContent: `C'est un insigne honneur pour nous que de prendre la parole devant d'éminents personnalités. Aussi, voudrions-nous vous remercier pour avoir pris sur votre temps pour rehausser de votre presence cette ceremonie.

Monsieur le Ministre De La Santé Publique, nous vous remercions vivement pour avoir accepté de patronner cette ceremonie.

Permettez-nous tout d'abord de saisir cette opportunité, pour exprimer toute notre reconnaissance à l'endroit de jury qui, sur la base de ses critères, a porté son choix sur notre Clinique. Nous sommes tres touchés et tres honorés par cette marque d'estime à l'attention de notre structure.

Nous ne saurions cacher notre joie pour cette distinction, et surtout l'agreable surprise de la recevoir au moment où nous ne nous attendions pas et où, nous avons fait la decouverte de l'organe qui nous l'a attribué en recevant sa lettre d'information.

Mesdames et Messieurs

La Clinique medico-chrirugicale providence a été créee en 1995, au fil du temps, elle a evolué pour atteindre une capacité d'accueil d'une centaine de lit, avec possibilité d'extension. Elle est une Clinique à prise en charge complète fonctionnant 24h/24.

Elle couvre de nombreuses specialités telles que: Medicine Generale, Chirurgie Generale, Chirirurgie Orthopedique, Urologie, Neurologie, Gynecologie, Pediatrie, Cardiologie, Gastro-Enterique, Odonthostomatologie, Neurologie, Dermatologie, Ophtamologie Et Optique, Oto-Rhino-Laryngologie (ORL).

Mesdames ,Messieurs,

Nous avons tenu à vous associer à nous pour partager notre joie. Au delà de la gloriole pour nos modestes personnes,calà va booster davantage l'elan de tout le personnel de la Clinique pour achever la mise en place totale des bonnes pratiques medicales.nous travaillons durement pour appliquer les standards reconnus par l'OMS à l'effet d'obtenir une certification international.

Notre politique a toujours été orientée vers une meilleure prise en charge des patients ,cela implique de bonnes pratiques medicales. Et cette distinction nous prouve que nous sommes sur la bonne voie.

Mesdames et messieurs ,

Cette distinction temoigne de l'importance que l'ICE,une institution Africaine ,créee par des Africains et pour les Africains ,accorde à la vie humaine. Elle temoigne également du fait que les Africains ont decidé de prendre en main leur destin.c'est le signe palpable d'un éveil des consciences. Celà n'empeche pas une collaboration entre le nord et le sud,au contraire ,elle la rendra plus fluide. En effet ,nos amis en occident ont également leurs problemes pour ne s'occuper que des notres.

Mesdames et messieurs

Certains se poseront la question sur la credibilité de l'ICE,mais je leur dis ceci "cette institution aura la credibilité si tous les Africains veulent la lui donner. Et la valeur de ses decisions en decoulera forcement."

En 1984,le regreté professeur CHEIKH ANT DIOP avait tenu une brillante conference à Niamey au Niger.il avait fourni toutes les preuves scientifiques de ses recherches.Mais à la fin ,toutes les questions se resumaient en une seule: les occidentaux accepteront-ils les resultats de vos recherches? Il a repondu ceci: "oui,pour vous ,la verité est blanche".il est temps de briser les chaines de l'alienation mentale ,car la science est universelle.

Le prix que la Clinique recoit aujourd'hui doit servir d'une part,à montrer la voie de l'excellence à ceux qui ont embrassé l'entrepreneuriat,et d'autre part,à faire comprendre à nos jeunes freres et à nos enfants qu'en dehors de la fonction publique,il existe une alternative.

Je vous remercie`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2023/06/pca-cmcp-300x169-3.jpg'
    },
    {
        id: 'correia',
        title: 'Mot du Vice-Premier Ministre Dr OLAVO CORREIA (Cap Vert)',
        speaker: 'Dr OLAVO CORREIA',
        position: 'Vice-Premier Ministre, Ministre des Finances',
        country: 'Cap-Vert',
        category: 'Gouvernement',
        date: '2024',
        excerpt: 'Un moment pour célébrer le fait qu\'un Cap-Verdien ait été sélectionné pour recevoir ce prestigieux prix panafricain.',
        fullContent: `Un moment pour célébrer le fait qu'un Cap-Verdien ait été sélectionné pour recevoir ce prestigieux prix panafricain, décerné par le Comité International d'Excellence.

Un acte qui mérite notre reconnaissance, qui nous rend tous fiers en tant que Nation.

M. Mário Semedo mérite pleinement cette distinction. Il rassemble les caractéristiques fondamentales qui font de lui un grand leader, non seulement au Cap-Vert, mais dans le monde entier. C'est un leader transformateur, sa capacité à se fixer des objectifs ambitieux et à obtenir des résultats, sa capacité à captiver et à mobiliser une équipe, en plus de son intégrité personnelle et de son humilité, sont des attributs qui font de lui un véritable fonctionnaire et un grand homme de main.

Verdien.

Au nom du gouvernement, nous félicitons M. Mário Semedo pour cette distinction et le remercions pour l'exemple qu'il représente, non seulement pour le secteur sportif, mais pour tous ceux qui aspirent à être des leaders d'excellence, fierté de notre Nation.

Je formule le vœu que vos initiatives soient couronnées de succès afin d'inspirer d'autres institutions et organes de notre Sous-région.`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2024/08/mot-du-vpm-1-1024x683.jpg'
    },
    {
        id: 'akouangue',
        title: 'Mot de Circonstance du General Gervais Akouangue DG/ Gendarmerie Nationale/Congo',
        speaker: 'General Gervais Akouangue',
        position: 'Commandant de la Gendarmerie Nationale',
        country: 'Congo',
        category: 'Forces de sécurité',
        date: '2024',
        excerpt: 'Avant tout propos, permettez-moi, au nom de la gendarmerie nationale, de traduire toute ma reconnaissance.',
        fullContent: `Monsieur le President du Comité Consultaif de Internatonal Committee Of Excellence
Messieurs les Officiers , en vos rangs,grades et qualités
Tres chers invités
Monsieur le President,

Je vous salue

Avant tout propos,ermettez moi ,au nom de la gendarmerie nationale de traduire toute ma reconnaissance et dire un grand merci à votre comité pour le choix devolu en ma modeste Personne.

Car ,cest avec une grande surprise ,joie imense ,hesitation et humilité que je recois cette distinction,que vous avez bien voulu me decerner

Par –là de ma personne,c'est toute une institution qui est felicitée. C'est tout de meme un motif de fierté.

Cette reconnaissance nous interpelle,elle est ercue cmme une exhortation à aller de l'avant.il nous reviendra de faire plus pour le rayonnement de notre arme.nous en sommes conscients

C'est une surprise,car on ne s'y attendait as, qu'un regard exterieur aporte son attention à la gendarmerie nationale.

Naturellement nous resectons votre choix et nous pensons que vcela decoule bien d'un jugement franc,fait d'une observation minutieuse,d'une evaluation sincere,en se fonfant sur une grille d'analyse,assurement

En tant que comité emanat de la societé civile,promouvant les valeurs d'ehtique,de bonnes pratiques ,de meritocratie et de aix,au niveau continental,nous ne ouvons que vous encourager à oursuivre cette noble tache ,à perseverer dans cette voie.l'Afrique à besoin de ses dignes fils ,la societé civile y constitue un pole important.grace à votre apport et votre action eclairée,que notre continent boostera son developpement,ar la bonne gouvernance multisectorielle,tant pronée par votre organisation.ce n'est que dans cette lancée orientée vers la resilience que notre continent jouera un role clé dans ce monde devenu globalisé et competitif,ou la reusite est au bout de l'excellence.nous vous shortons à continuer sur cette voie.

Votre organisation,voudrai-je dire ,se doit de jouer sa partition,en tant que l'un des leviers sur lesquels l'Afrique doit s'appuyer.celà vous exige de demeurer imaginatif,droit ,examplaire,juste et intraitable dans vos choix et votre travail,en s'appuyant toujours sur votre doctrine,de manière à maintenir le cap de votre vision

Ceci dit,et au nom de la gendarmerie nationale,je vous dis merci`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2025/04/31bdfdf8-2c4b-437b-a9a7-b039471f8802-300x169.jpg'
    },
    {
        id: 'pandi',
        title: 'Discours de M.Bertrand Eric Fedhere PANDI, President de la chambre des Notaires du Congo',
        speaker: 'M.Bertrand Eric Fedhere PANDI',
        position: 'Président de la chambre des Notaires du Congo',
        country: 'Congo',
        category: 'Justice',
        date: '2025',
        excerpt: 'Les discours des personnalités ci-après disponibles bientôt.',
        fullContent: `Les discours des personnalités ci-après disponibles bientôt.

S.E LEOPOLDINE COFFIE /EX-MINISTRE VICE -PRESIDENTE PDCI-RDA COTE D'IVOIRE
Me PAUL BERTIN ARNAUD ZEHOURI NOTAIRE /CONSEIL COTE D'IVOIRE
Me SYLVESTRE TAMO CMR
MINISTRE DJONO`,
        imageUrl: 'http://ice-inter.com/wp-content/uploads/2025/03/LAUREAT-PANDI-210x300.jpg'
    }
];

// --- Catégories et pays pour le filtrage ---
const categories = ['Tous', ...Array.from(new Set(speeches.map(s => s.category)))];
const countries = ['Tous', ...Array.from(new Set(speeches.map(s => s.country)))];

export const DiscoursPage: React.FC = () => {
    const [selectedCategory, setSelectedCategory] = useState('Tous');
    const [selectedCountry, setSelectedCountry] = useState('Tous');
    const [selectedSpeech, setSelectedSpeech] = useState<typeof speeches[0] | null>(null);

    const filteredSpeeches = speeches.filter(speech => {
        const categoryMatch = selectedCategory === 'Tous' || speech.category === selectedCategory;
        const countryMatch = selectedCountry === 'Tous' || speech.country === selectedCountry;
        return categoryMatch && countryMatch;
    });

    return (
        <PublicLayout>
            <SEOMetaTags
                title="Discours - International Committee of Excellence (ICE)"
                description="Découvrez les discours inspirants des lauréats et personnalités distingués par l'ICE. Témoignages d'excellence africaine."
            />

            <div className="bg-[#0d1321] text-white">
                {/* --- Section Héros --- */}
                <section
                    className="relative py-32 md:py-48 flex items-center justify-center text-center"
                    style={{
                        backgroundImage: 'url(http://ice-inter.com/wp-content/uploads/2024/08/mot-du-vpm-1-1024x683.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        backgroundAttachment: 'fixed'
                    }}
                >
                    <div className="absolute inset-0 bg-gradient-to-br from-[#0d1321]/80 via-[#0d1321]/60 to-[#d2ab6a]/20"></div>
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"></div>
                    <div className="relative z-10 container mx-auto px-4">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="flex justify-center mb-6"
                        >
                            <div className="text-[#d2ab6a] w-20 h-20 flex items-center justify-center">
                                <Quote className="w-full h-full" />
                            </div>
                        </motion.div>
                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="text-4xl md:text-6xl font-bold text-white mb-4"
                        >
                            Discours d'<span className="text-[#d2ab6a]">Excellence</span>
                        </motion.h1>
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto"
                        >
                            Les paroles inspirantes des leaders et lauréats qui ont marqué l'histoire des distinctions panafricaines.
                        </motion.p>
                    </div>
                </section>

                {/* --- Section Filtres --- */}
                <section className="py-12">
                    <div className="container mx-auto px-4">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="flex flex-col md:flex-row gap-6 justify-center mb-12"
                        >
                            <div className="flex flex-col">
                                <label className="text-white/70 mb-2 font-medium">Catégorie</label>
                                <select
                                    value={selectedCategory}
                                    onChange={(e) => setSelectedCategory(e.target.value)}
                                    className="bg-[#1a1f35] border-2 border-white/30 rounded-xl px-5 py-3 text-white placeholder-white/50 focus:border-[#d2ab6a] focus:bg-[#1e2438] focus:outline-none focus:ring-2 focus:ring-[#d2ab6a]/30 transition-all duration-300 hover:border-white/40 hover:bg-[#1e2438] cursor-pointer appearance-none"
                                    style={{
                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%23ffffff\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                        backgroundPosition: 'right 0.75rem center',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: '1.5em 1.5em',
                                        paddingRight: '3rem'
                                    }}
                                >
                                    {categories.map(category => (
                                        <option
                                            key={category}
                                            value={category}
                                            className="bg-[#1a1f35] text-white py-2"
                                        >
                                            {category}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-white/70 mb-2 font-medium">Pays</label>
                                <select
                                    value={selectedCountry}
                                    onChange={(e) => setSelectedCountry(e.target.value)}
                                    className="bg-[#1a1f35] border-2 border-white/30 rounded-xl px-5 py-3 text-white placeholder-white/50 focus:border-[#d2ab6a] focus:bg-[#1e2438] focus:outline-none focus:ring-2 focus:ring-[#d2ab6a]/30 transition-all duration-300 hover:border-white/40 hover:bg-[#1e2438] cursor-pointer appearance-none"
                                    style={{
                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%23ffffff\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                        backgroundPosition: 'right 0.75rem center',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: '1.5em 1.5em',
                                        paddingRight: '3rem'
                                    }}
                                >
                                    {countries.map(country => (
                                        <option
                                            key={country}
                                            value={country}
                                            className="bg-[#1a1f35] text-white py-2"
                                        >
                                            {country}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </motion.div>

                        {/* --- Grille des Discours --- */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {filteredSpeeches.map((speech, i) => (
                                <motion.div
                                    key={speech.id}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: i * 0.1 }}
                                    className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-[#d2ab6a]/30 transition-colors cursor-pointer group"
                                    onClick={() => setSelectedSpeech(speech)}
                                >
                                    <div className="flex items-start space-x-4 mb-4">
                                        <img
                                            src={speech.imageUrl}
                                            alt={speech.speaker}
                                            className="w-16 h-16 rounded-full object-cover flex-shrink-0"
                                        />
                                        <div className="flex-1">
                                            <h3 className="text-white font-bold text-lg group-hover:text-[#d2ab6a] transition-colors">
                                                {speech.speaker}
                                            </h3>
                                            <p className="text-[#d2ab6a] text-sm">{speech.position}</p>
                                            <div className="flex items-center space-x-4 mt-2 text-white/60 text-sm">
                                                <div className="flex items-center space-x-1">
                                                    <MapPin className="w-4 h-4" />
                                                    <span>{speech.country}</span>
                                                </div>
                                                <div className="flex items-center space-x-1">
                                                    <Calendar className="w-4 h-4" />
                                                    <span>{speech.date}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <span className="inline-block bg-[#d2ab6a]/20 text-[#d2ab6a] px-3 py-1 rounded-full text-xs font-medium mb-3">
                                            {speech.category}
                                        </span>
                                        <p className="text-white/80 leading-relaxed text-sm">
                                            {speech.excerpt}
                                        </p>
                                    </div>

                                    <button className="w-full bg-[#d2ab6a] text-[#0d1321] hover:bg-[#c19b59] inline-flex items-center justify-center space-x-2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300">
                                        <span>Lire le discours complet</span>
                                        <ChevronDown className="w-4 h-4" />
                                    </button>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* --- Modal pour le discours complet --- */}
                {selectedSpeech && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
                        onClick={() => setSelectedSpeech(null)}
                    >
                        <motion.div
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            className="bg-[#0d1321] rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="p-8">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center space-x-4">
                                        <img
                                            src={selectedSpeech.imageUrl}
                                            alt={selectedSpeech.speaker}
                                            className="w-16 h-16 rounded-full object-cover"
                                        />
                                        <div>
                                            <h2 className="text-2xl font-bold text-white">{selectedSpeech.speaker}</h2>
                                            <p className="text-[#d2ab6a]">{selectedSpeech.position}</p>
                                            <p className="text-white/60 text-sm">{selectedSpeech.country} • {selectedSpeech.date}</p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setSelectedSpeech(null)}
                                        className="text-white/60 hover:text-white transition-colors"
                                    >
                                        ✕
                                    </button>
                                </div>

                                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                                    <h3 className="text-xl font-bold text-[#d2ab6a] mb-4">{selectedSpeech.title}</h3>
                                    <div className="text-white/90 leading-relaxed whitespace-pre-line">
                                        {selectedSpeech.fullContent}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}

                {/* --- Section Statistiques --- */}
                <section className="py-20 bg-white/5">
                    <div className="container mx-auto px-4 text-center">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                                Archive des <span className="text-[#d2ab6a]">Discours</span>
                            </h2>
                            <p className="text-white/80 max-w-2xl mx-auto mb-12">
                                Une collection précieuse des paroles d'excellence qui ont marqué l'histoire de l'ICE.
                            </p>

                            <div className="grid md:grid-cols-4 gap-8">
                                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                    <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                        <BookOpen className="w-full h-full" />
                                    </div>
                                    <div className="text-4xl font-bold text-[#d2ab6a] mb-2">{speeches.length}+</div>
                                    <p className="text-white/70">Discours archivés</p>
                                </div>

                                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                    <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                        <MapPin className="w-full h-full" />
                                    </div>
                                    <div className="text-4xl font-bold text-[#d2ab6a] mb-2">{countries.length - 1}</div>
                                    <p className="text-white/70">Pays représentés</p>
                                </div>

                                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                    <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                        <User className="w-full h-full" />
                                    </div>
                                    <div className="text-4xl font-bold text-[#d2ab6a] mb-2">{speeches.length}</div>
                                    <p className="text-white/70">Leaders inspirants</p>
                                </div>

                                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                    <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                        <Quote className="w-full h-full" />
                                    </div>
                                    <div className="text-4xl font-bold text-[#d2ab6a] mb-2">100%</div>
                                    <p className="text-white/70">Authenticité</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </section>
            </div>
        </PublicLayout>
    );
};

export default DiscoursPage;
